import React from 'react'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles'
import ModalThemeProvider from './ModalThemeProvider'

const HelpModal = props => (
    <ModalThemeProvider>
        <Typography variant="display1"
            align="center"
            paragraph>
            哇你发现了新大陆！
        </Typography>
        <Typography variant="body1"
            align="center"
            paragraph>
            这里是文献引用助手。意在解决EndNote等软件格式不直观、速度慢的问题
        </Typography>
        <Typography variant="body2"
            align="center"
            paragraph>
            点击格式设置可以选择模板！
        </Typography>
        <Typography variant="body2"
            align="center"
            paragraph>
            粘贴之前记得改粘贴格式！操作方法：word文件→选项→高级→从其他程序粘贴→合并格式
        </Typography>
        <Button variant="raised"
            color="primary"
            className={props.classes.button}
            fullWidth
            onClick={() => props.onClick()}>
            知道了
        </Button>
    </ModalThemeProvider>
)

export default withStyles()(HelpModal)


// WEBPACK FOOTER //
// ./src/components/modals/help.js